<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import SummaryOverview from './components/SummaryOverview.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summaryOverviewRef = ref(null);

const onDownloadClick = () => {
  summaryOverviewRef.value.downloadReports();
};
</script>

<template>
  <ReportHeader
    :header-title="$t('OVERVIEW_REPORTS.HEADER')"
    :header-description="$t('OVERVIEW_REPORTS.DESCRIPTION')"
  >
    <V4Button
      :label="$t('OVERVIEW_REPORTS.DOWNLOAD')"
      icon="i-ph-file-arrow-down"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <SummaryOverview ref="summaryOverviewRef" />
</template>
